
const userHasBlockedAds = async () => {
  try {
    const url = `https://securepubads.g.doubleclick.net/pagead/ppub_config?ippd=www.carwow.co.uk&cachebust=${new Date().getTime()}`
    await fetch(url, { mode: 'no-cors' })
  } catch (error) {
    return true
  }
  return false
}

export const hideSlotsIfUserBlocksAds = () => {
  userHasBlockedAds().then(adsAreBlocked => {
    if (adsAreBlocked) {
      window.addEventListener('DOMContentLoaded', (_e) => {
        console.log('Looks like you are running ad blocker.')
        document.querySelectorAll('.google-ad').forEach(node =>{
          node.style.display = 'none';
        })
      })
    }
  })
}
